import React from 'react';
import HeaderComponent from '../components/General/HeaderComponent';
import { ProCreateComponent } from '../components/ProCreateComponent';

export default function CreateProject() {
  return (
    <div className="w-full dark:bg-dark-100 bg-stone-100 min-h-screen">
      <div className="container mx-auto">
        <HeaderComponent title="Yeni Proje Oluştur" />
        <div className="mt-8">
          <ProCreateComponent />
        </div>
      </div>
    </div>
  );
}
